module.exports = __webpack_public_path__ + "static/img/xl_btn2.d2312c1.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/home/pc/role3/control/xl_btn2.png
// module id = p+kc
// module chunks = 7